import React from "react";
import { NavLink, useNavigate, Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2, LayoutDashboard, Building2, Users, FileText, Star, Settings, LogOut, ExternalLink, MapPin, Hammer, UserCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

const NAV = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/projects", label: "Projects", icon: Building2 },
  { to: "/admin/leads", label: "Leads", icon: Users },
  { to: "/admin/locations", label: "Locations", icon: MapPin },
  { to: "/admin/builders", label: "Builders", icon: Hammer },
  { to: "/admin/team", label: "Team", icon: UserCircle },
  { to: "/admin/blogs", label: "Blogs", icon: FileText },
  { to: "/admin/testimonials", label: "Testimonials", icon: Star },
  { to: "/admin/settings", label: "Settings", icon: Settings },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  if (user === null) return <div className="min-h-screen flex items-center justify-center bg-navy"><Loader2 className="w-8 h-8 text-gold animate-spin" /></div>;
  if (!user) return <Navigate to="/admin/login" replace />;

  return (
    <div className="min-h-screen flex bg-slate-50">
      <aside className="w-16 md:w-64 bg-navy text-white flex flex-col shrink-0">
        <div className="p-4 md:p-6 border-b border-white/10">
          <p className="font-display text-lg text-white hidden md:block">Mathura Admin</p>
          <p className="font-display text-lg text-gold md:hidden text-center">M</p>
        </div>
        <nav className="flex-1 p-2 md:p-4 space-y-1">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end} data-testid={`admin-nav-${n.label.toLowerCase()}`}
              className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${isActive ? "bg-gold text-navy" : "text-gray-300 hover:bg-white/10"}`}>
              <n.icon className="w-5 h-5 shrink-0" strokeWidth={1.5} /> <span className="hidden md:inline">{n.label}</span>
            </NavLink>
          ))}
        </nav>
        <div className="p-2 md:p-4 border-t border-white/10 space-y-1">
          <button onClick={() => window.open("/", "_blank")} className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-gray-300 hover:bg-white/10 w-full">
            <ExternalLink className="w-5 h-5 shrink-0" /> <span className="hidden md:inline">View Site</span>
          </button>
          <button onClick={() => { logout(); navigate("/admin/login"); }} data-testid="admin-logout" className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-gray-300 hover:bg-white/10 w-full">
            <LogOut className="w-5 h-5 shrink-0" /> <span className="hidden md:inline">Logout</span>
          </button>
        </div>
      </aside>
      <main className="flex-1 overflow-x-hidden"><Outlet /></main>
    </div>
  );
}
